export enum EventSettings {
  HOSTS = 'HOSTS',
  SENDER_INFORMATION = 'SENDER_INFORMATION',
  RSVP = 'RSVP',
  DISPLAY_AND_PRIVACY = 'DISPLAY_AND_PRIVACY',
  NOTIFICATIONS = 'NOTIFICATIONS',
  SEO = 'SEO',
  LEGAL = 'LEGAL',
  INTEGRATIONS = 'INTEGRATIONS',
  LANGUAGE = 'LANGUAGE',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  HEADER_AND_FOOTER = 'HEADER_AND_FOOTER',
}

export namespace EventSettings {
  export function getAllEventSettings(): EventSettings[] {
    return [
      EventSettings.HOSTS,
      EventSettings.SENDER_INFORMATION,
      EventSettings.RSVP,
      EventSettings.DISPLAY_AND_PRIVACY,
      EventSettings.SEO,
      // EventSettings.LEGAL,
      EventSettings.INTEGRATIONS,
      // EventSettings.NOTIFICATIONS,
    ];
  }

  export function getGeneralEventSettings(): EventSettings[] {
    return [
      EventSettings.HOSTS,
      EventSettings.SENDER_INFORMATION,
      EventSettings.RSVP,
      EventSettings.LANGUAGE,
      EventSettings.SOCIAL_MEDIA,
    ];
  }

  export function getPerformanceEventSettings(): EventSettings[] {
    return [
      EventSettings.DISPLAY_AND_PRIVACY,
      EventSettings.HEADER_AND_FOOTER,
      EventSettings.SEO,
      // EventSettings.LEGAL,
    ];
  }

  export function getToolsEventSettings(): EventSettings[] {
    return [EventSettings.INTEGRATIONS];
  }

  export function getDisplayName(setting?: EventSettings): string {
    switch (setting) {
      case EventSettings.HOSTS:
        return 'APP.EVENT_SETTINGS.HOSTS.TITLE';
      case EventSettings.SENDER_INFORMATION:
        return 'APP.EVENT_SETTINGS.SENDER_INFORMATION.TITLE';
      case EventSettings.RSVP:
        return 'APP.EVENT_SETTINGS.RSVP.TITLE';
      case EventSettings.DISPLAY_AND_PRIVACY:
        return 'APP.EVENT_SETTINGS.DISPLAY_AND_PRIVACY.TITLE';
      case EventSettings.NOTIFICATIONS:
        return 'APP.EVENT_SETTINGS.NOTIFICATIONS.TITLE';
      case EventSettings.SEO:
        return 'APP.EVENT_SETTINGS.SEO.TITLE';
      case EventSettings.LEGAL:
        return 'APP.EVENT_SETTINGS.LEGAL.TITLE';
      case EventSettings.INTEGRATIONS:
        return 'APP.EVENT_SETTINGS.INTEGRATIONS.TITLE';
      case EventSettings.LANGUAGE:
        return 'APP.EVENT_SETTINGS.LANGUAGE.TITLE';
      case EventSettings.SOCIAL_MEDIA:
        return 'APP.EVENT_SETTINGS.SOCIAL_MEDIA.TITLE';
      case EventSettings.HEADER_AND_FOOTER:
        return 'APP.EVENT_SETTINGS.HEADER_AND_FOOTER.TITLE';
      default:
        return '';
    }
  }

  export function getIcon(setting?: EventSettings): string {
    switch (setting) {
      case EventSettings.HOSTS:
        return 'fa-regular fa-crown';
      case EventSettings.SENDER_INFORMATION:
        return 'fa-regular fa-list-ul';
      case EventSettings.RSVP:
        return 'fa-regular fa-messages';
      case EventSettings.DISPLAY_AND_PRIVACY:
        return 'fa-regular fa-gears';
      case EventSettings.NOTIFICATIONS:
        return 'fa-regular fa-bell';
      case EventSettings.SEO:
        return 'fa-regular fa-pen';
      case EventSettings.LEGAL:
        return 'fa-regular fa-gavel';
      case EventSettings.INTEGRATIONS:
        return 'fa-regular fa-link';
      case EventSettings.LANGUAGE:
        return 'fa-regular fa-language';
      case EventSettings.SOCIAL_MEDIA:
        return 'fa-regular fa-square-share-nodes';
      case EventSettings.HEADER_AND_FOOTER:
        return 'fa-regular fa-distribute-spacing-vertical';
      default:
        return '';
    }
  }
}
